/**
 * Format cents as USD currency string
 * @param {number} cents
 * @returns {string} e.g. "$49.99"
 */
export function formatPrice(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100)
}

/**
 * Create a DOM element with attributes and children
 * @param {string} tag
 * @param {Object} attrs
 * @param {...(string|Node)} children
 * @returns {HTMLElement}
 */
export function el(tag, attrs = {}, ...children) {
  const element = document.createElement(tag)
  for (const [key, val] of Object.entries(attrs)) {
    if (key === 'class') {
      element.className = val
    } else if (key.startsWith('on')) {
      element.addEventListener(key.slice(2).toLowerCase(), val)
    } else if (key === 'html') {
      element.innerHTML = val
    } else {
      element.setAttribute(key, val)
    }
  }
  for (const child of children) {
    if (child == null) continue
    element.append(typeof child === 'string' ? child : child)
  }
  return element
}

/**
 * Set innerHTML safely (tags only, no scripts)
 */
export function setHTML(element, html) {
  element.innerHTML = html
}

/**
 * Debounce a function
 */
export function debounce(fn, ms = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }
}

/**
 * Show a toast notification
 * @param {string} message
 * @param {'success'|'error'} type
 * @param {number} duration ms
 */
export function showToast(message, type = 'success', duration = 3500) {
  let container = document.getElementById('toast-container')
  if (!container) {
    container = document.createElement('div')
    container.id = 'toast-container'
    document.body.appendChild(container)
  }

  const toast = document.createElement('div')
  toast.className = `toast toast-${type}`
  toast.textContent = message
  container.appendChild(toast)

  setTimeout(() => {
    toast.style.opacity = '0'
    toast.style.transition = 'opacity 0.3s ease'
    setTimeout(() => toast.remove(), 300)
  }, duration)
}

/**
 * Truncate text to maxLength with ellipsis
 */
export function truncate(str, maxLength = 100) {
  if (!str || str.length <= maxLength) return str
  return str.slice(0, maxLength).trimEnd() + '…'
}

/**
 * Get URL query param
 */
export function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name)
}

/**
 * Simple image placeholder (returns data URL for gray box)
 */
export function imagePlaceholder(w = 400, h = 300) {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${w}' height='${h}'%3E%3Crect width='100%25' height='100%25' fill='%231e1e1e'/%3E%3C/svg%3E`
}
